<span class="label-popover-container position-relative"
      [matTooltip]="'backlog.task_assignee.trigger_tooltip' | translate"
      [matTooltipDisabled]="selectedItems.length > 0">
    <!-- Bouton pour ouvrir le popover -->
    <button class="btn btn-blue" 
            [ngClass]="context"
            [disabled]="selectedItems.length === 0 || availableManagers.length === 0"
            (click)="togglePopover()">
        @if(context === 'backlogList') {<i class="fa-regular fa-user-plus"></i> }
        <span class="px-2">{{'backlog.task_details.assign' | translate}}</span>
        @if(context === 'taskDetails') {<i class="fa-sharp-duotone fa-solid fa-chevron-down"></i>}    
    </button>
  
    <!-- Popover -->
    @if (isPopoverOpen) {
        <div class="popover-backdrop" (click)="togglePopover()"></div>
        <task-assignee-popover  [managers]="availableManagers"
                                [selectedAssignees]="assignees"
                                (assigneesChange)="onAssigneeSelectionChanged($event)"
                                (apply)="onApply($event)"></task-assignee-popover>
    }
</span>